import { useEffect, useState } from "react";
import { GeoJSON, Pane, useMap, useMapEvents } from "react-leaflet";
import { useAppSelector } from "Hooks/useRedux";
import useStreets from "Hooks/useStreets";

export default function Streets() {
  const { visible, searchQuery } = useAppSelector((state) => state.streets);
  const [bbox, setBbox] = useState<string>("");

  const map = useMap();

  const updateBbox = () => {
    const bounds = map.getBounds();
    const bboxString = `${bounds.getWest()},${bounds.getSouth()},${bounds.getEast()},${bounds.getNorth()}`;
    setBbox(bboxString);
  };

  useMapEvents({
    moveend: () => {
      if (visible) {
        updateBbox();
      }
    },
  });

  useEffect(() => {
    if (visible && !bbox) {
      updateBbox();
    }
  }, [visible]);

  // لیمیت را می‌توانی بسته به نیازت کم و زیاد کنی
  const {
    data: streetsData,
    isFetching,
    dataUpdatedAt,
  } = useStreets({
    bbox: searchQuery ? undefined : bbox,
    name: searchQuery !== "" ? searchQuery : undefined,
    limit: 300,
  });

  const geoJsonStyle = (feature: any) => {
    let lineColor = "#3388ff";
    let lineWeight = 4;

    if (feature.properties && feature.properties.fclass === "primary") {
      // طبق عکس postman ممکنه اسم فیلد fclass باشه
      lineColor = "#42e73cff";
      lineWeight = 5;
    }

    return { color: lineColor, weight: lineWeight, opacity: 0.8 };
  };

  const onEachFeature = (feature: any, layer: any) => {
    if (feature.properties && feature.properties.name) {
      layer.bindTooltip(`<span style="font-family: Tahoma; font-size: 12px">${feature.properties.name}</span>`, {
        sticky: true,
        direction: "top",
      });
    }

    layer.on({
      mouseover: (e: any) => {
        e.target.setStyle({ weight: geoJsonStyle(feature).weight + 3, opacity: 1 });
      },
      mouseout: (e: any) => {
        e.target.setStyle({ weight: geoJsonStyle(feature).weight, opacity: 0.8 });
      },
    });
  };

  if (!visible) return null;

  return (
    <Pane name="streets-pane" style={{ zIndex: 450 }}>
      {isFetching && (
        <div
          style={{
            position: "absolute",
            top: 10,
            left: 50,
            zIndex: 1000,
            background: "white",
            padding: "5px 10px",
            borderRadius: "5px",
            fontSize: "12px",
          }}
        >
          در حال دریافت معابر... ⏳
        </div>
      )}

      <div style={{ opacity: isFetching ? 0.5 : 1, transition: "opacity 0.3s" }}>
        {streetsData && (
          <GeoJSON key={`streets-layer-${dataUpdatedAt}`} data={streetsData} style={geoJsonStyle} onEachFeature={onEachFeature} />
        )}
      </div>
    </Pane>
  );
}
